import { ClipboardArrowUpIcon } from './ClipboardArrowUpIcon';

/**
 * author: James Coyle
 * id 5F084570-4F64-4A94-A762-602350ACEDAA
 * name clipboard-arrow-up
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clipboard-arrow-up.svg
 * tags
 */
export const ClipboardArrowTopIcon = ClipboardArrowUpIcon;
export default ClipboardArrowTopIcon